import { Btn1,Bars } from "../../Module_Exporter/Module_Exporter";
import { website_routes } from "../../functions/DefaultValues";
import "./Header.css";
import Typewriter from 'typewriter-effect';

const Header = (props)=>
{

    


return (
<>
           <header id="Main_Header">

<div className="header_left">
   <Bars aos="fade-left" color="c2" width="70%" height="0.5rem" />
   <h1 data-aos="fade-right" className="heading">
       We are Expert in<br/> 
       <span>
       <Typewriter
  options={{
    strings: props.services,
    autoStart: true,
    loop: true,
  }}/>
        </span>
   </h1>
   <p data-aos="fade-left" >{props.introPhrase()}</p>
   <div data-aos="fade-right"  className="header_btn_container">

  <Btn1   cl="header_btn scaling_animation"  value="CONTACT US" url={website_routes.contact_page} />
  <Btn1   cl="header_btn scaling_animation"  value="Our Services" url={website_routes.services_page} />
   </div>

</div>
{/* <div className="header_right">
    <div className=" scaling_animation img_container">
        <img src={Coding_image} alt="Coding" />
    
    </div>

</div> */}


 </header>
       
        </>
    )
}
Header.defaultProps={
    introPhrase:"Welcome to [Your Company Name]! We are your one-stop solution for all things web-related. From expert web development that brings your ideas to life, to strategic SEO services that boost your online visibility, and stunning web and app UI/UX designs that captivate your audience – we've got you covered. Let's elevate your digital presence together and create a seamless and delightful user experience that leaves a lasting impression. Get ready to take your online journey to new heights with our top-notch services!",
    services:["Web Development","Web Designing","E-Commerce Store","Search Engine Optimization"]
}
export default Header;





